import { render, staticRenderFns } from "./GraficoEvolucaoIndiceVegetacao.vue?vue&type=template&id=6a2fc13c&lang=pug"
import script from "./GraficoEvolucaoIndiceVegetacao.vue?vue&type=script&lang=js"
export * from "./GraficoEvolucaoIndiceVegetacao.vue?vue&type=script&lang=js"
import style0 from "./GraficoEvolucaoIndiceVegetacao.vue?vue&type=style&index=0&id=6a2fc13c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports